<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area public-js">
            <!-- <js-header
                class="js-header js-desktop-view"
                v-if="headerBar"
                :menu-listing="menuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></js-header> -->
            <base-header
                class="js-desktop-view register-customer-header"
                v-if="headerBar"
                :menu-listing="menuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <!-- <base-header
        v-if="headerBar"
        :menu-listing="menuListing"
        step-style
        @sidemenu="$emit('responsiveSideBar')"
      ></base-header> -->
            <div
                :class="{
                    'right-panel': headerBar,
                }"
            >
                <div
                    :class="{
                        'wrap-content': headerBar,
                        'customer-section': headerBar,
                    }"
                >
                    <div class="filter-section" v-if="headerBar">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div
                        :class="{
                            card: headerBar,
                        }"
                    >
                        <router-view></router-view>
                    </div>
                </div>
                <ul class="footer js-footer js-header js-desktop-view">
                    <li style="margin-bottom: 38px; margin-top: 40px">
                        JS Investments Digital Onboarding | Powered by Idenfo
                    </li>
                </ul>
            </div>
            <js-footer
                class="js-header js-desktop-view"
                v-if="headerBar"
            ></js-footer>
            <!-- <base-footer
             class="js-mobile-view"
                    v-if="headerBar"
                ></base-footer> -->
        </div>
        <base-footer
            class="js-mobile-view"
            v-if="headerBar"
            style="position: static"
        ></base-footer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import axios from 'axios'
import JsHeader from '../../components/registration/JsHeader'
import JsFooter from '../../components/registration/JsFooter'

export default {
    components: {
        JsHeader,
        JsFooter,
    },
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        dataForm: {
            type: Object,
            required: true,
        },
        tempData: {
            type: Object,
            required: true,
        },
        languageOption: {
            type: String,
        },
    }, // End of Component > props
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            headerBar: false,
            menuListing: [
                // {
                //   anchorLink: '/register-customer/',
                //   menuLabel: 'Intial Form',
                //   sessionStep: '1',
                //   name: 'initial-form',
                //   permission: ['register-customer'],
                // },
                {
                    // anchorLink: '/register-customer/',
                    menuLabel: 'Identity Document',
                    sessionStep: '1',
                    name: 'identity-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/record-video',
                    menuLabel: 'Record Video',
                    sessionStep: '2',
                    name: 'record-video',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '3',
                    name: 'setup-profile',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Account Info',
                    sessionStep: '4',
                    name: 'account-info',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/kyc',
                    menuLabel: 'KYC',
                    sessionStep: '5',
                    name: 'kyc',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'RPQ',
                    sessionStep: '6',
                    name: 'investment',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Risk Profile',
                    sessionStep: '7',
                    name: 'risk-product',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '8',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Preview',
                    sessionStep: '9',
                    name: 'upload',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '10',
                    name: 'upload',
                    permission: ['register-customer'],
                },
            ],
            genders: null,
        }
    }, // End of Component > data
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),
        dataSegmentId() {
            // console.log("compute-main");
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.headerBar = this.$route.meta.headerBar

            // if (this.$route.params.dataSegmentId) {
            //     return this.$route.params.dataSegmentId
            // }
            return process.env.VUE_APP_RC_ACCOUNT
        },
    }, // End of Component > mounted
    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            // console.log("watch-main");
            if (value) {
                // this.goToFirstStep()
                this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        if (this.$route.meta.publicRegistration === true) {
            this.checkDataSegment()
        }
        // this.goToFirstStep()
        this.checkOcrSwitch()
        this.$store.commit('initDefaultFields', 'form')
        this.languageOption = this.$route.params.languageOption
        this.dataForm = this.$route.params.dataForm
        this.tempData = this.$route.params.tempData
        // if (this.dataForm) {
        //     this.updateForm(this.dataForm)
        //     // this.registerTempCustomer();
        //     this.getRecords()
        // }
        
        // this.$root.$on('updateTempCustomer',  this.updateTemp())

        this.$root.$on(
            'updateTempCustomer',
            function () {
                this.updateTemp()
            }.bind(this)
        )

        if (this.tempData) {
            this.$store.commit('setValue', {
                key: 'form',
                value: this.tempData,
            })
            if (!this.tempData.basicInfo.gender) {
                this.getRecords()
            }
        }

        if (this.languageOption) {
            this.$store.commit('updateField', {
                key: 'languageOption',
                value: this.languageOption,
            })
        } else {
            this.$store.commit('updateField', {
                key: 'languageOption',
                value: 'en',
            })
        }
    }, // End of Component > computed

    beforeDestroy() {
        this.$root.$off('updateTempCustomer', function () {
                this.updateTemp()
            })
    },
    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        async updateTemp() {
            if (this.$route.meta.publicRegistration === true) {
                try {
                    const formData = this.$store.state.registration.form
                    // console.log("FormData: " + formData);

                    var str = this.$store.getters.getField(
                        'identityInfo.number'
                    )
                    var newStr = str.replace(/-/g, '')
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: newStr,
                    })

                    axios
                        .post('/api/customers/temp-customer-update', formData)
                        .then((response) => {
                            // console.log("data", response.data);
                            // this.setValuesForRadio(this.data.data);
                            this.$store.commit('registration', {
                                key: 'form',
                                value: response.data,
                            })

                            this.$store.commit('setSuccess', response.message)
                        })
                        .catch((error) => {
                            this.errorMessage = error.message
                            this.$store.commit(
                                'setError',
                                'Something went wrong'
                            )
                            // console.error('There was an error!', error)
                        })
                } catch (err) {
                    console.log(err)
                    this.$store.commit('setError', 'Something went wrong')
                }
            }
        },
        /**
         * go to the first step
         *
         * @return {void}
         */
        goToFirstStep() {
            if (
                !['identity-document', 'new-signup'].includes(this.$route.name)
            ) {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'new-signup',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'identity-document',
                    })
                }
            }
        }, // End of goToFirstStep() method
        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
                this.$store.commit('setValue', {
                    key: 'useOcr',
                    value: data.data.switch,
                })
                this.$store.commit('setValue', {
                    key: 'restrictDuplicateCustomers',
                    value: data.data.restrictDuplicateCustomers,
                })
            } catch (error) {
                // console.log(error)
            }
        }, // End of checkOcrSwitch() method

        async checkDataSegment() {
            try {
                const { data } = await request({
                    url: `/configurations/check-dataSegment`,
                    method: 'post',
                    data: { dataSegmentId: this.dataSegmentId },
                })

                if (data) {
                    if (data.status == 'fail') {
                        this.$router.push('/404')
                    }
                } else {
                    this.$router.push('/404')
                }
            } catch (error) {
                this.$router.push('/404')
            }
        }, // End of checkOcrSwitch() method

        async getRecords() {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: '/configurations/genders',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.genders = data.data

                let lastDigit = (this.tempData.identityInfo.number % 10) % 2

                if (lastDigit == 1) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: 'Male',
                    })

                    let genderID = this.genders.find(
                        (elem) => elem.title == 'Male'
                    )
                    this.$store.commit('updateField', {
                        key: 'basicInfo.genderId',
                        value: genderID._id,
                    })
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.gender',
                        value: genderID.value,
                    })
                    console.log(
                        'gender ',
                        this.$store.state.registration.form.basicInfo.gender
                    )
                } else if (lastDigit == 0) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: 'Female',
                    })
                    let genderID = this.genders.find(
                        (elem) => elem.title == 'Female'
                    )
                    this.$store.commit('updateField', {
                        key: 'basicInfo.genderId',
                        value: genderID._id,
                    })
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.gender',
                        value: genderID.value,
                    })
                    console.log(
                        'gender ',
                        this.$store.state.registration.form.basicInfo.gender
                    )
                } else {
                    return
                }
            } catch (error) {
                // console.log(error)
            }
        }, // End of getRecords() method
    }, // End of Component > watch
} // End of export default
</script>